import { DependencyList, useMemo, useRef } from 'react';

// use-react has useCustomCompareEffect but lacks useCustomCompareMemo

export const useCustomCompareMemo = function <T>(
  factory: () => T,
  deps: DependencyList | undefined,
  depsEqual: (newDeps?: DependencyList, prevDeps?: DependencyList) => boolean,
): T {
  if (process.env.NODE_ENV !== 'production') {
    if (!(deps instanceof Array) || !deps.length) {
      console.warn(
        '`useCustomCompareMemo` should not be used with no dependencies. Use React.useMemo instead.',
      );
    }
    if (typeof depsEqual !== 'function') {
      console.warn(
        '`useCustomCompareMemo` should be used with depsEqual callback for comparing deps list',
      );
    }
  }
  const ref = useRef<DependencyList>([]);
  if (!ref.current || !depsEqual(deps, ref.current)) {
    ref.current = deps ?? [];
  }
  return useMemo(factory, ref.current);
};
